import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let roerenewworkPermitDraftPageMachine: any;

const MODULE_NAME = 'machines.roerenewworkPermitDraft';
const log: any = LoggerModule?.getInstance();

export const useSMroerenewworkPermitDraftPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  roerenewworkPermitDraftPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(roerenewworkPermitDraftPageMachine);

  return {
    roerenewworkPermitDraftPageMachine,
    roerenewworkPermitDraftPageState: state,
    roerenewworkPermitDraftPageSend: send,
  };
};
